import { windowScroll, addClass, removeClass } from "./functions";

class scrollFunction {
  _el: HTMLElement;
  _triggerValue: number;

  constructor(idSelector:HTMLElement, triggerValue: number = 300) {
    this._el = idSelector;
    this._triggerValue = triggerValue;
  }

  /**
   * Handle class
   */
  handleClass = () => {
    if (document.body.scrollTop > this._triggerValue || document.documentElement.scrollTop > this._triggerValue) {
      addClass({domElement: this._el, classList: 'opacity-100'});
    } else {
      removeClass({domElement: this._el, classList: 'opacity-100'});
    }
  }

  /**
   * Even listner
   */
  evenListner = () => {
    // Add listener
      this._el.addEventListener('click', (e: MouseEvent) => {
          e.preventDefault();
          windowScroll();
      })
    }
}
export default scrollFunction;
  

